import React, { memo, ReactNode, useEffect } from "react";
import { useTranslate } from "@obsbot/remo-i18n";
import { usePageStore } from "../stores/page-store";
import { routeConfig, RouteNameType } from "../route-config";
import "./index.less";

const UserSettingLayoutContainerCom: React.FC<{ children: ReactNode }> = ({ children }) => {
    const t = useTranslate();
    const pageStore = usePageStore();

    useEffect(() => {
        const subMenu = [
            {
                key: routeConfig[RouteNameType.AccountSettingPage].path,
                title: t("settings.account-setting.title"),
                route: routeConfig[RouteNameType.AccountSettingPage].path,
            },
            {
                key: routeConfig[RouteNameType.RTCSettingPage].path,
                title: t("settings.rtc-setting.title"),
                route: routeConfig[RouteNameType.RTCSettingPage].path,
            },
            {
                key: routeConfig[RouteNameType.DisplaySettingPage].path,
                title: t("settings.display-setting.title"),
                route: routeConfig[RouteNameType.DisplaySettingPage].path,
            },
            {
                key: routeConfig[RouteNameType.GameOverlaySettingPage].path,
                title: t("settings.gameoverlay-setting.title"),
                route: routeConfig[RouteNameType.GameOverlaySettingPage].path,
            },
            {
                key: routeConfig[RouteNameType.HotKeySettingPage].path,
                title: t("settings.hotkey-setting.title"),
                route: routeConfig[RouteNameType.HotKeySettingPage].path,
            },
            {
                key: routeConfig[RouteNameType.SoftwareVersionPage].path,
                title: t("settings.software-version.title"),
                route: routeConfig[RouteNameType.SoftwareVersionPage].path,
            },
        ];
        if (!(window as any).electron) {
            subMenu.splice(3, 1);
        }
        // 配置submenu
        pageStore.configure({
            subMenu,
            activeKeys: ["settings", window.location.hash.slice(1)],
        });
        // WARNING: 这里不能加上pageStore, 否则会导致循环更新组件
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t]);

    return <div className="user-setting-layout-container">{children}</div>;
};

export const UserSettingLayoutContainer = memo(UserSettingLayoutContainerCom);
